export const SEARCH_TYPE = {
    k:"Typed In",
    h:"History",
    s:"Suggested",
    p:"Suggested - Product",
    "":"NA"
}